import React from 'react';
import styled from 'styled-components';
import { useParams } from 'react-router-dom';

import { useFetch } from '../../../hooks/useFetch';
import { productsApi } from '../../../api/product';

import Section from '../../../components/layout/Section';
import More from './More';
import SideMenu from './SideMenu';
import MainBody from '../../../components/layout/MainBody';

const Wrapper = styled.div`
	display: flex;
	flex-direction: row;
	flex-wrap: no-wrap;
	justify-content: flex-start;
	align-items: flex-start;
	width: 90%;
	max-width: 1320px;
	gap: 50px;

	@media (max-width: 1080px) {
		flex-direction: column;
		align-items: stretch;
		gap: 30px;
	}
`;

const LeftMenu = styled.div`
	min-width: 480px;
	max-width: 900px;
	display: flex;
	flex-direction: column;
	justify-content: flex-start;
	gap: 80px;
	flex-grow: 1;
	flex-shrink: 1;
	
	@media (max-width: 1080px) {
		display: contents;
	}
`;

const RightMenu = styled.div`
	width: 370px;
	position: sticky;
	top: 270px;
	right: 0px;

	@media (max-width: 1080px) {
		display: contents;
	}
`;

const MainImage = styled.div`
	width: auto;
	height: 600px;
	flex-grow: 1;

	@media (max-width: 1080px) {
		order: 1;
	}

	box-sizing: border-box;
`;

export const SideMenuStyle = styled.div`
	width: 370px;
	display: flex;
	flex-direction: column;
	justify-content: flex-start;
	gap: 45px;

	@media (max-width: 1080px) {
		order: 2;
		width: 100%;
	}
`;

export const MoreStyle = styled.div`
	width: auto;

	display: flex;
	flex-direction: column;
	justify-content: flex-start;
	gap: 50px;

	@media (max-width: 1080px) {
		order: 3;
	}
`;

export default function Detail() {
	const params = useParams();
	const productCode = params.productCode;

	const { data, loading, error} = useFetch(productsApi.getProductDetail, [productCode]);

	if(loading) {
		return ;
	}

	return (
		<MainBody>
			<Section>
				<Wrapper>
					<LeftMenu>
						<MainImage>
							<img src={ data.productThumbnail } width="100%" height="100%" />
						</MainImage>
						<More detailImage={ data.productDetail } />
					</LeftMenu>
					<RightMenu><SideMenu data={data} productCode={productCode} /></RightMenu>
				</Wrapper>
			</Section>
		</MainBody>
  	);
}